<template>
  <div>
    <PageHeader title="Engagements" subtitle="Every meeting, call and email with your prospects, pulled from their Events and Tasks in Salesforce." :heading-level="1">
      <template #actions>
        <button v-if="status.connected" type="button" class="btn-secondary-sm" :disabled="syncing" @click="sync">
          <font-awesome-icon :icon="['fas', syncing ? 'spinner' : 'rotate']" :class="{ 'fa-spin': syncing }" />
          {{ syncing ? 'Syncing…' : 'Sync now' }}
        </button>
      </template>
    </PageHeader>

    <div class="px-6 py-4">
      <Engagement_Table :key="tableKey" entity-type="Prospect" />
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue'
import Engagement_Table from '@/components/Lists/Engagement_Table.vue'

export default {
  name: 'EngagementsTab',
  components: { FontAwesomeIcon, PageHeader, Engagement_Table },
  data() {
    return { syncing: false, status: { connected: false }, tableKey: 0 }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      const { data } = await this.$axios.get('/api/growth/salesforce/status/')
      this.status = data
    },
    async sync() {
      this.syncing = true
      try {
        await this.$axios.post('/api/growth/salesforce/sync/')
        await this.load()
        this.tableKey += 1
      } finally {
        this.syncing = false
      }
    },
  },
}
</script>
